// @flow
import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../services/apiService/apiService';
import {
  paymentModeDisplayNameToEnumMap,
  paymentStatusRespEnum
} from '../../../commons/editPaymentDetailsModal/editPaymentDetailsHelper';

const failureMsg = 'Failed to perform operation';

export const retailCollectionsActions = {
  SET_RTL_COLLECTIONS_DATE_FILTER: 'SET_RTL_COLLECTIONS_DATE_FILTER',
  GET_COLLECTIONS_SUMMARY: 'GET_COLLECTIONS_SUMMARY',
  FILTER_COLLECTIONS_SUMMARY_TABLE_DATA:
    'FILTER_COLLECTIONS_SUMMARY_TABLE_DATA',
  EDIT_PAYMENT_DETAILS: 'EDIT_PAYMENT_DETAILS',
  GET_BANK_DETAILS: 'GET_BANK_DETAILS',
  GET_RIVIGO_BANK_DETAILS: 'GET_RIVIGO_BANK_DETAILS',
  GET_ALLOWED_PAYMENT_TYPES: 'GET_ALLOWED_PAYMENT_TYPES',
  GET_SHORT_PAYMENT_REASONS: 'GET_SHORT_PAYMENT_REASONS',
  TDS_APPLICABLE: 'TDS_APPLICABLE',
  SET_LOCATION_FILTER_VALUE: 'SET_LOCATION_FILTER_VALUE'
};

export const setDateFilter = (startDate = false, endDate = false) => ({
  type: retailCollectionsActions.SET_RTL_COLLECTIONS_DATE_FILTER,
  payload: { startDate, endDate }
});

export const setLocationFilterValue = locationId => ({
  type: retailCollectionsActions.SET_LOCATION_FILTER_VALUE,
  payload: { locationId }
});

export const filterTableData = (filterObj: Object) => ({
  type: retailCollectionsActions.FILTER_COLLECTIONS_SUMMARY_TABLE_DATA,
  payload: filterObj
});

export const getCollectionsSummaryAction = (obj: Object) => ({
  type: retailCollectionsActions.GET_COLLECTIONS_SUMMARY,
  payload: obj
});

export const getCollectionsSummary = (retailCollectionsState, userProfile) => (
  dispatch: Function
) => {
  dispatch(
    getCollectionsSummaryAction({
      isLoading: true,
      isLoaded: false,
      tableData: null,
      tableDataFiltered: null
    })
  );

  const paramsArr = [
    { key: 'fromDate', val: retailCollectionsState.filterValues.startDate },
    { key: 'toDate', val: retailCollectionsState.filterValues.endDate }
  ];

  if (
    retailCollectionsState.filterValues.locationId != null &&
    retailCollectionsState.filterValues.locationId != undefined
  ) {
    paramsArr.push({
      key: 'locationId',
      val: retailCollectionsState.filterValues.locationId
    });
  }

  if (userProfile.authorities.indexOf('ROLE_VIEW_COLLECTIONS_HANDOVER') >= 0) {
    paramsArr.push({ key: 'isLocation', val: 'true' });
  }

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getCollectionsSummary',
    replaceParamsArr: paramsArr,
    successCb: res => {
      // eslint-disable-next-line no-console
      console.log('Fetched Retail Collections Summary ', res);
      if (res.status === 'SUCCESS') {
        const data = {
          isLoading: false,
          isLoaded: true,
          tableData: res.payload,
          tableDataFiltered: res.payload
        };
        dispatch(getCollectionsSummaryAction(data));
      } else if (res.status === 'FAILURE') {
        dispatch(
          getCollectionsSummaryAction({
            isLoading: false,
            isLoaded: true,
            tableData: [],
            tableDataFiltered: []
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(
        ' Failure in fetching retail collections summary, res= ',
        res
      );
      dispatch(
        getCollectionsSummaryAction({
          isLoading: false,
          isLoaded: true,
          tableData: [],
          tableDataFiltered: []
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(' Exception in fetching retail collections summary', res);
      dispatch(
        getCollectionsSummaryAction({
          isLoading: false,
          isLoaded: true,
          tableData: [],
          tableDataFiltered: []
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const makeEditPaymentCallAction = (data: Object) => ({
  type: retailCollectionsActions.EDIT_PAYMENT_DETAILS,
  payload: data
});

export const makeTdsApplicableCall = (phoneNumber, isDelivery) => (
  dispatch: Function
) => {
  dispatch(
    getTdsApplicableAction({
      tdsApplicableData: {
        data: { status: null, val: null }
      }
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'tdsApplicable',
    replaceParamsArr: [
      { key: 'phoneNumber', val: phoneNumber },
      { key: 'isDelivery', val: isDelivery }
    ],
    successCb: res => {
      // eslint-disable-next-line no-console
      console.log('tdsApplicable success ', res);
      if (res.status === 'SUCCESS') {
        dispatch(
          getTdsApplicableAction({
            tdsApplicableData: {
              data: { status: 'success', val: res.payload }
            }
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getTdsApplicableAction({
            tdsApplicableData: {
              data: { status: 'failure', val: res }
            }
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(' tdsApplicable failure, res= ', res);
      dispatch(
        getTdsApplicableAction({
          tdsApplicableData: {
            data: { status: 'failure', val: res }
          }
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(' Exception in tdsApplicable ', res);
      dispatch(
        getTdsApplicableAction({
          tdsApplicableData: {
            data: { status: 'exception', val: res }
          }
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const makeEditPaymentCall = (
  editPaymentData,
  transactionScreenshotFile,
  tanCertificateFile
) => (dispatch: Function) => {
  dispatch(
    makeEditPaymentCallAction({
      editPaymentModalData: {
        isLoading: true,
        isLoaded: false,
        preventResetData: true,
        data: { status: null, val: null }
      }
    })
  );

  const formData = new FormData();
  formData.append(
    'paymentDetailsDTO',
    new Blob([JSON.stringify(editPaymentData)], {
      type: 'application/json'
    })
  );
  if (transactionScreenshotFile) {
    formData.append('paymentReceiptFile', transactionScreenshotFile);
  }

  if (tanCertificateFile) {
    formData.append('tanCertificateFile', tanCertificateFile);
  }

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'makeEditPaymentCall',
    method: 'POST',
    postFormData: true,
    data: formData,
    successCb: res => {
      // eslint-disable-next-line no-console
      console.log('makeEditPaymentCall success ', res);
      if (res.status === 'SUCCESS') {
        toastr.success('Success', 'Payment Details updated succcessfully');
        dispatch(
          makeEditPaymentCallAction({
            editPaymentModalData: {
              isLoading: false,
              isLoaded: true,
              preventResetData: false,
              data: {
                status: 'success',
                val: 'Payment Details updated succcessfully'
              }
            }
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          makeEditPaymentCallAction({
            editPaymentModalData: {
              isLoading: false,
              isLoaded: true,
              preventResetData: true,
              data: { status: 'failure', val: res.errorMessage }
            }
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(' makeEditPaymentCall failure, res= ', res);
      toastr.error('Error', res.errorMessage || failureMsg);
      dispatch(
        makeEditPaymentCallAction({
          editPaymentModalData: {
            isLoading: false,
            isLoaded: true,
            preventResetData: true,
            data: { status: 'failure', val: res.errorMessage }
          }
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(' Exception in makeEditPaymentCall ');
      toastr.error('Error', failureMsg);
      dispatch(
        makeEditPaymentCallAction({
          editPaymentModalData: {
            isLoading: false,
            isLoaded: true,
            preventResetData: true,
            data: { status: 'exception', val: res }
          }
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const getBankDetailsAction = (data: Object) => ({
  type: retailCollectionsActions.GET_BANK_DETAILS,
  payload: data
});

export const getTdsApplicableAction = (data: Object) => ({
  type: retailCollectionsActions.TDS_APPLICABLE,
  payload: data
});

export const getBankDetails = () => (dispatch: Function) => {
  dispatch(
    getBankDetailsAction({
      bankDetailsData: {
        isLoading: true,
        isLoaded: false,
        data: { status: null, val: null }
      }
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getBankDetails',
    successCb: res => {
      // eslint-disable-next-line no-console
      console.log('getBankDetails success ', res);
      if (res.status === 'SUCCESS') {
        dispatch(
          getBankDetailsAction({
            bankDetailsData: {
              isLoading: false,
              isLoaded: true,
              data: { status: 'success', val: res.payload }
            }
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getBankDetailsAction({
            bankDetailsData: {
              isLoading: false,
              isLoaded: true,
              data: { status: 'failure', val: res }
            }
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(' getBankDetails failure, res= ', res);
      dispatch(
        getBankDetailsAction({
          bankDetailsData: {
            isLoading: false,
            isLoaded: true,
            data: { status: 'failure', val: res }
          }
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(' Exception in getBankDetails ', res);
      dispatch(
        getBankDetailsAction({
          bankDetailsData: {
            isLoading: false,
            isLoaded: true,
            data: { status: 'exception', val: res }
          }
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const getRivigoBankDetailsAction = (data: Object) => ({
  type: retailCollectionsActions.GET_RIVIGO_BANK_DETAILS,
  payload: data
});

export const getShortPaymentReasonsAction = (data: Object) => ({
  type: retailCollectionsActions.GET_SHORT_PAYMENT_REASONS,
  payload: data
});

export const getRivigoBankDetails = () => (dispatch: Function) => {
  dispatch(
    getRivigoBankDetailsAction({
      rivigoBankDetailsData: {
        isLoading: true,
        isLoaded: false,
        data: { status: null, val: null }
      }
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getRivigoBankDetails',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getRivigoBankDetailsAction({
            rivigoBankDetailsData: {
              isLoading: false,
              isLoaded: true,
              data: { status: 'success', val: res.payload }
            }
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getRivigoBankDetailsAction({
            rivigoBankDetailsData: {
              isLoading: false,
              isLoaded: true,
              data: { status: 'failure', val: res }
            }
          })
        );
      }
    },
    failureCb: res => {
      dispatch(
        getRivigoBankDetailsAction({
          rivigoBankDetailsData: {
            isLoading: false,
            isLoaded: true,
            data: { status: 'failure', val: res }
          }
        })
      );
    },
    catchCb: res => {
      dispatch(
        getRivigoBankDetailsAction({
          rivigoBankDetailsData: {
            isLoading: false,
            isLoaded: true,
            data: { status: 'exception', val: res }
          }
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const getShortPaymentReasons = () => (dispatch: Function) => {
  dispatch(
    getShortPaymentReasonsAction({
      shortPaymentReasons: {
        isLoading: true,
        isLoaded: false,
        data: { status: null, val: null }
      }
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'shortPaymentReasons',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getShortPaymentReasonsAction({
            shortPaymentReasons: {
              isLoading: false,
              isLoaded: true,
              data: { status: 'success', val: res.payload }
            }
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getShortPaymentReasonsAction({
            shortPaymentReasons: {
              isLoading: false,
              isLoaded: true,
              data: { status: 'failure', val: null }
            }
          })
        );
      }
    },
    failureCb: () => {
      dispatch(
        getShortPaymentReasonsAction({
          shortPaymentReasons: {
            isLoading: false,
            isLoaded: true,
            data: { status: 'failure', val: null }
          }
        })
      );
    },
    catchCb: res => {
      dispatch(
        getShortPaymentReasonsAction({
          shortPaymentReasons: {
            isLoading: false,
            isLoaded: true,
            data: { status: 'exception', val: res }
          }
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const getAllowedPaymentTypesAction = (data: Object) => ({
  type: retailCollectionsActions.GET_ALLOWED_PAYMENT_TYPES,
  payload: data
});

export const getAllowedPaymentTypes = (paymentMode, amount) => (
  dispatch: Function
) => {
  dispatch(
    getAllowedPaymentTypesAction({
      allowedPaymentTypes: {
        isLoading: true,
        isLoaded: false,
        data: { status: null, val: null }
      }
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getAllowedPaymentTypes',
    replaceParamsArr: [
      { key: 'paymentMode', val: paymentMode },
      { key: 'totalRoundOffAmount', val: amount }
    ],
    successCb: res => {
      // eslint-disable-next-line no-console
      console.log('getAllowedPaymentTypes success ', res);
      if (res.status === 'SUCCESS') {
        dispatch(
          getAllowedPaymentTypesAction({
            allowedPaymentTypes: {
              isLoading: false,
              isLoaded: true,
              data: { status: 'success', val: res.payload }
            }
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getAllowedPaymentTypesAction({
            allowedPaymentTypes: {
              isLoading: false,
              isLoaded: true,
              data: { status: 'failure', val: res }
            }
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log(' getAllowedPaymentTypes failure, res= ', res);
      dispatch(
        getAllowedPaymentTypesAction({
          allowedPaymentTypes: {
            isLoading: false,
            isLoaded: true,
            data: { status: 'failure', val: res }
          }
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(' Exception in getAllowedPaymentTypes ', res);
      dispatch(
        getAllowedPaymentTypesAction({
          allowedPaymentTypes: {
            isLoading: false,
            isLoaded: true,
            data: { status: 'exception', val: res }
          }
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const makeGetChequeNumberCall = (chequeImageFile, cb) => (
  dispatch: Function
) => {
  const formData = new FormData();

  if (chequeImageFile) {
    formData.append('chequeFile', chequeImageFile);
  }

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'makeGetChequeNumberCall',
    method: 'POST',
    postFormData: true,
    data: formData,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        if (res.payload.ocrChequeNumber) {
          cb({ ocrChequeNumber: res.payload.ocrChequeNumber });
        } else {
          cb({ ocrChequeNumber: null });
        }
      } else {
        cb({ ocrChequeNumber: null });
      }
    },
    failureCb: res => {
      cb({ ocrChequeNumber: null });
    },
    catchCb: res => {
      cb({ ocrChequeNumber: null });
    }
  };
  return makeApiCall(requestObj);
};

export const getUtrDetails = (utrNo, cb) => (dispatch: Function) => {
  if (!utrNo) {
    return;
  }

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getUtrDetails',
    method: 'GET',
    pathVariables: [{ key: '{utrNo}', val: utrNo }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        cb(res.payload);
      } else {
        cb({});
      }
    },
    failureCb: () => {
      cb({});
    },
    catchCb: () => {
      cb({});
    }
  };
  return makeApiCall(requestObj);
};

{
  /**
   * Initiate payment method for sending new payment request
   * @param data Object user data for creation of new payment link
   * @param cb Callback function to receive transactionId and paymentLink
   */
}
export const initiateOnlinePayment = (data, cb) => {
  const initiateOnlinePaymentCall = paymentData => {
    const reqObj = {
      baseUrl: 'zoomApiUrl',
      apiEndPoint: 'initiatePayment',
      method: 'POST',
      data: paymentData,
      successCb: res => {
        if (res.status === 'SUCCESS' && res.payload.status === 'INITIATED') {
          toastr.success(
            'Success',
            `Payment Link Successfully sent to mobile ${res.payload.mobileNumber}`
          );
          cb(res.payload);
        } else {
          cb(res);
        }
      },
      failureCb: res => {
        toastr.error('Error', res.errorMessage || failureMsg);
        cb(res);
      },
      catchCb: res => {
        toastr.error('Error', res.errorMessage || failureMsg);
        cb(res);
      }
    };
    return makeApiCall(reqObj);
  };
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getConsignmentById',
    method: 'GET',
    pathVariables: [{ key: '{id}', val: data.consignmentId }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        const phone = data.mobileNumber
          ? data.mobileNumber
          : res.payload.paymentDetailsDTO &&
            res.payload.paymentDetailsDTO.paymentMode ===
              paymentModeDisplayNameToEnumMap.PAID
          ? res.payload.consignorPhone
          : res.payload.consigneePhone;
        console.log(phone);
        const initialPaymentData = {
          consignmentDTOList: [res.payload],
          forCodDod: false,
          mobileNumber: phone,
          tdsApplicable: false,
          totalAmount: data.totalAmount
        };
        if (
          res.payload.paymentDetailsDTO &&
          res.payload.onlinePaymentDetails &&
          res.payload.paymentDetailsDTO.paymentType === 'ONLINE' &&
          res.payload.onlinePaymentDetails.id &&
          res.payload.onlinePaymentDetails.status ===
            paymentStatusRespEnum.INITIATED &&
          !data.changeNumberModal
        ) {
          cb(res.payload.onlinePaymentDetails);
        } else {
          initiateOnlinePaymentCall(initialPaymentData);
        }
      }
    },
    failureCb: res => {
      toastr.error('Error', res.errorMessage || failureMsg);
      cb(res);
    },
    catchCb: res => {
      toastr.error('Error', res.errorMessage || failureMsg);
      cb(res);
    }
  };
  return makeApiCall(requestObj);
};

{
  /**
   * Check the status of online payment if paid by the User through the link
   * @param id query param TransactionId for status query
   * @param cb Callback to receive the status where called
   */
}
export const checkOnlinePaymentStatus = (id, cb) => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'checkOnlinePaymentStatus',
    method: 'GET',
    pathVariables: [{ key: '{transactionId}', val: id }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        if (res.payload.status === 'COMPLETED') {
          toastr.success(
            'Payment Successful',
            `Payment of ₹${res.payload.amount} received successfully!`
          );
        }
        cb(res.payload);
      }
    },
    failureCb: res => {
      toastr.error('Error', res.errorMessage || failureMsg);
      cb(res);
    },
    catchCb: res => {
      toastr.error('Error', res.errorMessage || failureMsg);
      cb(res);
    }
  };
  return makeApiCall(requestObj);
};

{
  /**
   * Cancel latest payment request
   * @param id Latest payment id for cancellation
   * @param cb Callback function
   */
}
export const cancelOnlinePayment = (id, cb) => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'cancelOnlinePayment',
    method: 'DELETE',
    pathVariables: [{ key: '{transactionId}', val: id }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        cb(res.payload);
      }
    },
    failureCb: res => {
      toastr.error('Error', res.errorMessage || failureMsg);
      cb(res);
    },
    catchCb: res => {
      toastr.error('Error', res.errorMessage || failureMsg);
      cb(res);
    }
  };
  return makeApiCall(requestObj);
};

{
  /**
   * Resend payment link to the current/changed mobile
   * @param id transactionId, link sent for this id
   */
}
export const resendPaymentLink = (id, cb) => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'resendPaymentLink',
    method: 'PUT',
    pathVariables: [{ key: '{transactionId}', val: id }],
    successCb: res => {
      if (res && res.status === 'SUCCESS') {
        if (res.payload === 'Success') {
          toastr.success('Success', 'Link sent again');
        } else {
          toastr.error('Error', 'Error in sending link again.');
        }
        cb(res);
      }
    },
    failureCb: res => {
      toastr.error('Error', res.errorMessage || failureMsg);
      cb(res);
    },
    catchCb: res => {
      toastr.error('Error', res.errorMessage || failureMsg);
      cb(res);
    }
  };
  return makeApiCall(requestObj);
};
